module.exports = __webpack_public_path__ + "img/g1.3a5c0d66.png";